import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Menu } from '../_model/menu';
import { UtilService } from '../_service/util.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  menus: Menu[];
  linksMercedesWorld = [
    {
      label: 'Site Institucional',
      title: 'Site Institucional',
      href: 'https://www.mercedes-benz-trucks.com.br/',
    },
    {
      label: 'Showroom',
      title: 'Showroom',
      href: 'https://showroommercedes-benz.com.br',
    },
    {
      label: 'Caminhões',
      title: 'Caminhões',
      href: 'https://www.mercedes-benz-trucks.com.br/caminhoes/',
    },
    {
      label: 'Ônibus',
      title: 'Ônibus',
      href: 'https://www.mercedes-benz-trucks.com.br/onibus/',
    },
    {
      label: 'Banco Mercedes-Benz',
      title: 'Banco Mercedes-Benz',
      href: 'https://www.bancomercedes-benz.com.br/',
    },
    {
      label: 'Peças e Serviços',
      title: 'Peças e Serviços',
      href: 'https://www.mercedes-benz-trucks.com.br/caminhoes/servicos-e-pecas/',
    },
  ];
  private dropdowns: NodeListOf<Element> = null!;
  private backdrop: HTMLElement | null = null;

    constructor(private activatedRoute: ActivatedRoute,
        private utilService: UtilService) { }

  ngOnInit(): void {
    const documents = this.activatedRoute.snapshot.data['documentos'];
    this.utilService.urlCodigoEtica = documents.find(document => document.codigo === 'CodigoEtica').url;
    this.menus = this.utilService.getMenus();
  }

  ngAfterViewInit(): void {
    this.dropdowns = document.querySelectorAll('.dropdown');
    this.backdrop = document.getElementById('dropdown-backdrop');

    this.dropdowns.forEach(dropdown => {
      dropdown.addEventListener('show.bs.dropdown', this.showBackdropAndLine);
      dropdown.addEventListener('hide.bs.dropdown', this.hideBackdropAndLine);
    });

    this.backdrop?.addEventListener('click', this.closeDropdowns);
  }

  ngOnDestroy(): void {
    this.dropdowns?.forEach(dropdown => {
      dropdown.removeEventListener('show.bs.dropdown', this.showBackdropAndLine);
      dropdown.removeEventListener('hide.bs.dropdown', this.hideBackdropAndLine);
    });
    this.backdrop?.removeEventListener('click', this.closeDropdowns);
  }

  private showBackdropAndLine = () => {
    this.backdrop?.classList.add('show');
    document.querySelector('nav')?.classList.add('active-menu');
  }

  private hideBackdropAndLine = () => {
    this.backdrop?.classList.remove('show');
    document.querySelector('nav')?.classList.remove('active-menu');
  }

  private closeDropdowns = () => {
    this.dropdowns.forEach(dd => {
      const btn = dd.querySelector('.dropdown-toggle');
      if (dd.classList.contains('show') && btn) {
        (btn as HTMLElement).click();
      }
    });
  }
}
